import {
  generateItemsReducer,

  generateItemAndActionsFromStore,
  generateItemListAndActionsFromStore,
} from "./item";

const itemType = "documentSetDocumentActivity";
const endpoint = "document_set_document_activities/";

export const documentSetDocumentActivitiesReducer = generateItemsReducer<DocumentSetDocumentActivitySnakeModel, {}>(itemType);

export const documentSetDocumentActivityAndActionsFromStore = generateItemAndActionsFromStore<DocumentSetDocumentActivitySnakeModel, {}, {}>(
  itemType,
  endpoint,
  (a, b, c, d) => ({}),
);

export const documentSetDocumentActivityListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, documentSetDocumentActivityAndActionsFromStore);
